import { Box, useMediaQuery } from '@mui/material';
import { useEffect } from 'react';
import { TableHeader } from '~/components/ListCardTable/TableHeader';
import { styles } from '../../styles';
import { EMPTY_NON_PROFIT, nonProfitTableColumns } from '../../constants';
import NonProfitTableRow from './NonProfitOrgTableRow';
import { theme } from '~/theme';
import { FormYesNoQuestion } from '~/components/FormComponents/FormYesNoQuestion';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { TPurposeOfBusinessRelations } from '../../types';
import { commonStyles } from '~/theme/styles/commonStyles';

export const NonProfitableOrg = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { watch, control, clearErrors } = useFormContext<TPurposeOfBusinessRelations>();
  const { fields, replace } = useFieldArray({
    control,
    name: 'nonProfitDetails',
  });
  const isNonProfitOrganization = watch('isNonProfitOrganization');

  useEffect(() => {
    if (!isNonProfitOrganization) {
      replace([]);
    }
  }, [isNonProfitOrganization]);

  const handleChange = (isChecked: boolean) => {
    if (isChecked) {
      replace([EMPTY_NON_PROFIT]);
    } else {
      replace([]);
      clearErrors('licenses');
    }
  };

  return (
    <>
      <FormYesNoQuestion
        question="Чи є юридична особа неприбутковою організацією?"
        tooltipTitle="Якщо Ви є неприбутковою організацією, необхідно додати рішення про включення до реєстру неприбуткових організацій в обов'язкові документи"
        name="isNonProfitOrganization"
        onChange={handleChange}
      />

      {isNonProfitOrganization && (
        <Box sx={styles.table}>
          {!isMobile && <TableHeader columns={nonProfitTableColumns} showActions={false} />}
          <Box sx={{ ...commonStyles.columnFlexContainer, gap: { sm: 2, md: 0, xs: 2 } }}>
            {fields.map((field, index: number) => (
              <NonProfitTableRow key={field.id} index={index} />
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};

export default NonProfitableOrg;
